module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dccd5059320d172d1b282564e0d9422d.svg";